import React, {FC} from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {ErrorMessage, Field} from 'formik'

const Step7: FC = () => {
  return (
    <div className='w-100'>
      <div className='w-100'>
        <div className='pb-5 pb-lg-5'>
          <h2 className='fw-bolder text-primary text-center'>Xác thực khuôn mặt</h2>
        </div>

        <div className='d-flex justify-content-center mt-4 flex-column align-items-center'>
          <div className='mx-5'>
            <img src={toAbsoluteUrl('/media/nhsv/illus-face.png')} alt='img' />
          </div>
          <span className='text-dark text-center mt-7'>
            Vui lòng thực hiện các thao tác xác thực khuôn mặt theo hướng dẫn và giữ điện thoại
            ngang tầm mắt ở khoảng cách 30-40cm
          </span>
        </div>

        <div className='mt-8'>
          <p className='fw-bold'>Vui lòng làm theo hướng dẫn</p>
          <div className='d-flex justify-content-around'>
            <div className='d-flex justify-content-center mt-4 flex-column align-items-center'>
              <div className='mx-5'>
                <img src={toAbsoluteUrl('/media/nhsv/glasse.png')} alt='img' />
              </div>
              <span className='text-dark text-center mt-7'>Không đeo kính râm</span>
            </div>
            <div className='d-flex justify-content-center mt-4 flex-column align-items-center'>
              <div className='mx-5'>
                <img src={toAbsoluteUrl('/media/nhsv/mask.png')} alt='img' />
              </div>
              <span className='text-dark text-center mt-7'>Không đeo khẩu trang, mũ/nón</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {Step7}
